import { SvgProps } from "../../../types";

const MeterManagementSvg = (props: SvgProps) => (
  <svg
    width={props.width ?? 20}
    height={props.height ?? 23}
    viewBox="0 0 20 23"
    fill="none"
    {...props}
  >
    <path
      d="M6.66667 22.2222V19.4444C4.7037 18.7593 3.10185 17.5602 1.86111 15.8472C0.62037 14.1343 0 12.1852 0 10C0 8.61111 0.263889 7.31018 0.791667 6.09722C1.31944 4.88426 2.03241 3.8287 2.93056 2.93056C3.8287 2.03241 4.88426 1.31944 6.09722 0.791667C7.31019 0.263889 8.60185 0 9.97222 0C11.3426 0 12.6389 0.263889 13.8611 0.791667C15.0833 1.31944 16.1481 2.03241 17.0556 2.93056C17.963 3.8287 18.6806 4.88426 19.2083 6.09722C19.7361 7.31018 20 8.61111 20 10C20 12.1852 19.375 14.125 18.125 15.8194C16.875 17.5139 15.2778 18.713 13.3333 19.4167V22.2222H11.1111V19.9444C10.9259 19.9815 10.7407 20 10.5556 20H9.97222C9.78704 20 9.60648 19.9954 9.43056 19.9861C9.25463 19.9769 9.07407 19.963 8.88889 19.9444V22.2222H6.66667ZM10 17.8333C12.1481 17.8333 13.9815 17.0741 15.5 15.5556C17.0185 14.037 17.7778 12.2037 17.7778 10.0556C17.7778 7.90741 17.0185 6.07407 15.5 4.55556C13.9815 3.03704 12.1481 2.27778 10 2.27778C7.85185 2.27778 6.01852 3.03704 4.5 4.55556C2.98148 6.07407 2.22222 7.90741 2.22222 10.0556C2.22222 12.2037 2.98148 14.037 4.5 15.5556C6.01852 17.0741 7.85185 17.8333 10 17.8333ZM5.55556 7.83333H14.4444V5.61111H5.55556V7.83333ZM9.16667 16.7222L12.5 13.3889L11.1111 12L12.5 10.6111L10.8333 8.94444L7.5 12.2778L8.88889 13.6667L7.5 15.0556L9.16667 16.7222Z"
      fill={props.fill ?? "#1F1F1F"}
    />
  </svg>
);

export default MeterManagementSvg;
